<template>
  <button class="button-toggle" :data-off="!state.isVisibleMCSController" @click="toggleMCSController">
    <ToggleSwitch :model-value="state.isVisibleMCSController" @update:model-value="toggleMCSController" />
    {{ t('label_mcs') }}
  </button>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { DEFAULT_CHAT_UI_STATE } from '@/utils/constants/chat';
import { ij_chat_ui, ij_setCurrentPopupMicInput } from '@/utils/injectionKeys';

const { actions, state } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE);
const setCurrentPopupMicInput = inject(ij_setCurrentPopupMicInput, (str) => {});

const { t } = useI18n();

const toggleMCSController = () => {
  if (state.isVisibleMCSPController) {
    actions.toggleMCSPController();
  }
  actions.toggleMCSController();
  setCurrentPopupMicInput('');
};
</script>

<style scoped lang="scss"></style>
